import http from '@/utils/http';
const base_path = '/v2/tool/creativeText';

/**
 * 获取创意文案接口
 * @param {Object} params 查询数据
 * @returns {Promise<Object>}
 */
export const getCreativeTextApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
